.title {
  /* stylelint-disable value-no-vendor-prefix */
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  /* stylelint-enable */

  @media (--md-down) {
    flex-shrink: 0;
    width: 100%;
  }
}

.pushApart {
  width: 0;
  margin-left: auto;
}

.top {
  padding-bottom: 1.5rem;
  border-bottom: 1px solid var(--secondary);
}

.row {
  display: flex;
  gap: 1rem;
  align-items: center;
  width: 100%;
  min-height: 48px; /* The toggle button pushes up the size on the alert page. This makes them align well when routing between tags/alerts*/
  margin: 1.5rem 0;
}
